module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_01"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_01#toc-anchor-1"
    }
  }, [_vm._v("In Danger")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_02"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_02#toc-anchor-2"
    }
  }, [_vm._v("A Dawning Criminal")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_03"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_03#toc-anchor-3"
    }
  }, [_vm._v("In and Out")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_04"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_04#toc-anchor-4"
    }
  }, [_vm._v("The Matthew Enigma")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_05"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_05#toc-anchor-5"
    }
  }, [_vm._v("Criminal Minds")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_06"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_06#toc-anchor-6"
    }
  }, [_vm._v("Bobby")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_07#toc-anchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not So Ordinary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_08#toc-anchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take a Swim")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_09#toc-anchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Signs")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_10#toc-anchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ordinary Bird")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_11#toc-anchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stash")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_12#toc-anchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_13#toc-anchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aladdin’s Cave")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_14#toc-anchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hoard")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_15#toc-anchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Little Thing")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_16#toc-anchor-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Victims")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_17#toc-anchor-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fulmer")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_18#toc-anchor-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60 Minutes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_19#toc-anchor-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Money")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_20#toc-anchor-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Turn")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_21#toc-anchor-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chasing Dollars")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_22#toc-anchor-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Break")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_23#toc-anchor-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chrysalis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_24#toc-anchor-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tragedy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_25#toc-anchor-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plot")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_26#toc-anchor-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tail-Checks")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_27#toc-anchor-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Girls")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_28#toc-anchor-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rec Yard")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_29#toc-anchor-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paint")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_30#toc-anchor-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loose Ends")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_31#toc-anchor-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sheep and Wolves")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_32#toc-anchor-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Trial")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_33#toc-anchor-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paper Terrorism")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_34#toc-anchor-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Property Trial")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_35#toc-anchor-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Following Through")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_36#toc-anchor-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mind of Monroe")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_37#toc-anchor-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Guys")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_38#toc-anchor-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Androgyny")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_39#toc-anchor-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bryan’s Trial")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_40#toc-anchor-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man Hunting")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_41#toc-anchor-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unpredictable")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_42#toc-anchor-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_43#toc-anchor-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buyer’s Remorse")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_44#toc-anchor-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bellagio")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_45#toc-anchor-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STOP CORUPTION")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_46#toc-anchor-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exposed")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_47#toc-anchor-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Right Thing")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_48#toc-anchor-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Smoking Gun")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_49#toc-anchor-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Convincing Science")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_50#toc-anchor-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distractions")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_51#toc-anchor-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Show")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_52#toc-anchor-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good Guy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_53#toc-anchor-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Arguments")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_54#toc-anchor-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verdicts")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_55#toc-anchor-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken on the Bone")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_56#toc-anchor-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poisoned Minds")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1 sgc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0